import { render, staticRenderFns } from "./attr-setting.vue?vue&type=template&id=46f09ff9&scoped=true"
import script from "./attr-setting.vue?vue&type=script&lang=js"
export * from "./attr-setting.vue?vue&type=script&lang=js"
import style0 from "./attr-setting.vue?vue&type=style&index=0&id=46f09ff9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46f09ff9",
  null
  
)

export default component.exports